import { Capacitor } from '@capacitor/core'
import { Preferences } from '@capacitor/preferences'
import { clearStoredUsernames } from './usernameStore'

const API_URL_KEY = 'apiUrl'
const API_URL_COOKIE_DAYS = 3650

function normalizeApiUrl(input: string): string {
  let normalized = input.trim()

  normalized = normalized.replace(/^https?:\/\//i, '')
  normalized = normalized.split('?')[0]
  normalized = normalized.split('#')[0]
  normalized = normalized.split('/')[0]
  normalized = normalized.replace(/\/+$/, '')

  return `https://${normalized}/api`
}

function setCookie(name: string, value: string, days = API_URL_COOKIE_DAYS) {
  const expires = new Date()
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)

  document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`
}

function deleteCookie(name: string) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/`
}

function getCookie(name: string): string | null {
  const match = document.cookie.split('; ').find((row) => row.startsWith(`${name}=`))

  if (!match) {
    return null
  }

  const value = match.split('=')[1]

  return value ? decodeURIComponent(value) : null
}

export async function setApiUrl(apiUrl: string) {
  const normalizedApiUrl = normalizeApiUrl(apiUrl)

  if (Capacitor.isNativePlatform()) {
    await Preferences.set({
      key: API_URL_KEY,
      value: normalizedApiUrl,
    })
    return
  }

  setCookie(API_URL_KEY, normalizedApiUrl)
}

export async function clearApiUrl() {
  if (Capacitor.isNativePlatform()) {
    await Preferences.remove({ key: API_URL_KEY })
    await clearStoredUsernames()
    return
  }

  deleteCookie(API_URL_KEY)
  await clearStoredUsernames()
}

export async function getApiUrl(): Promise<string | null> {
  if (Capacitor.isNativePlatform()) {
    const result = await Preferences.get({ key: API_URL_KEY })
    return result.value
  }

  if (typeof document === 'undefined') {
    return null
  }

  const value = getCookie(API_URL_KEY)

  if (value) {
    setCookie(API_URL_KEY, value)
  }

  return value
}
